import React from 'react';

import InputIcon from '@mui/icons-material/Input';

import AppLayout from "../application/AppLayout";

import { styled, Grid, Paper, Typography } from '@mui/material';

const PREFIX = 'UnauthorizedLayout';

const classes = {
  root: `${PREFIX}-root`,
  paper: `${PREFIX}-paper`
};

const StyledAppLayout = styled(AppLayout)((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    flexGrow: 1,
    height: '100%',
  },

  [`& .${classes.paper}`]: {
    width: '360px',
    height: '220px',
  }
}));

export default function UnauthorizedLayout() {


  return (
    <StyledAppLayout>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: 'calc(100% - 64px)' }}
      >
        <Grid item xs={12}>
          <Paper className={classes.paper} style={{width: '360px', height: '220px',}}>
            <div
              style={{
                height: '60px',
                width: '100%',
                padding: '16px',
                textAlign: 'center',
              }}
            >
              <InputIcon color="primary" style={{ fontSize: '64px' }} />
            </div>
            <div
              style={{
                width: '100%',
                textAlign: 'center',
                padding: '8px',
              }}
            >
              <Typography variant="h6" gutterBottom>
                Oh Snap!
              </Typography>
              <Typography variant="body2" gutterBottom>
                Looks like you don't know the secret handshake :(
              </Typography>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </StyledAppLayout>
  );
}
